import initJobsTable from '~/jobs/components/table';

initJobsTable();
